import React, {useState} from 'react'  
import IScalarForm from '../interface/IScalarForm'
import Scalar from './Scalar'
import Moment from "react-moment"  
import { DayPicker, SelectSingleEventHandler } from 'react-day-picker'
import { ru } from 'date-fns/locale';
import 'react-day-picker/dist/style.css'; 
import "moment/locale/ru"
import { Button, Popover } from '@blueprintjs/core'
import { __ } from 'src/libs/utilities'
import Hours from 'src/libs/useful/timers/Hours'
import Minutes from 'src/libs/useful/timers/Minutes'

const DateTime = ( props: IScalarForm ): JSX.Element => {
    return <Scalar 
        { ...props }
        enabledForm={<DateTimeEnabled {...props} />}
        desabledForm={<DateTimeDesabled {...props} />}
    />
} 

export default DateTime
 
export const DateTimeEnabled = ( props: IScalarForm ): JSX.Element => {
    const [value, setValue] = useState<Date>( !!props.value ? new Date(props.value * 1000) : new Date() )  
    const [hours, setHours] = useState<number>(0)
    const [minutes, setMinutes] = useState<number>(0)
    const onChange = (data: Date, data2: Date, data3: any) => {
        data.setMinutes( minutes )        
        data.setHours( hours )
        setValue( data )
        // console.log( data.getTime(), data )
        if(props.onChange && data) props.onChange( Math.floor( data.getTime()/ 1000 ), props.field, "" )
    }
    const onHours = (hours: number) => {
        setHours( hours )
        value.setHours( hours )
        if(props.onChange ) props.onChange( Math.floor( value.getTime()/ 1000 ), props.field, "" )
    }
    const onMinutes = (minutes: number) => {
        setMinutes( minutes )
        value.setMinutes( minutes )
        if(props.onChange ) props.onChange( Math.floor( value.getTime()/ 1000 ), props.field, "" )
    }
    const css = `
        .my-selected:not([disabled]) { 
            font-weight: bold; 
            border: 2px solid currentColor;
        }
        .my-selected:hover:not([disabled]) { 
            border-color: blue;
            color: blue;
        }
        .my-today { 
            font-weight: bold; 
            color: red;
        }
        `;
    return props.minimal
        ?
        <>
            <style>{css}</style>
            <Popover
                content={
                    <DayPicker
                        mode="single"
                        selected={ value }
                        numberOfMonths={1} 
                        onSelect={ onChange as SelectSingleEventHandler }
                        locale={ ru }
                        showOutsideDays
                        fixedWeeks 
                        modifiersClassNames={{
                            selected: 'my-selected',
                            today: 'my-today'
                        }}
                        modifiersStyles={{
                            disabled: { fontSize: '75%' }
                        }}
                    />
                }
            >
                <Button variant="minimal" >
                    <Moment locale="ru" format="D MMMM YYYY г.">
                        {new Date( value )}
                    </Moment>
                </Button>
            </Popover>
            <Popover
                content={
                    <div className="d-flex flex-column gap-20 p-4" style={{ gap: 20 }}> 
                        <Hours onChange={ onHours} hours={ hours } /> 
                        <Minutes onChange={ onMinutes } minutes={ minutes } />
                    </div>
                }
            >
                <Button variant="minimal" >
                    <Moment locale="ru" format="HH час. mm мин.">
                        {new Date( value )}
                    </Moment>
                </Button>
            </Popover>
        </>
        :
        <div>
            <style>{css}</style>
            <DayPicker
                mode="single"
                selected={ value }
                numberOfMonths={1} 
                onSelect={ onChange as SelectSingleEventHandler}
                locale={ ru }
                showOutsideDays
                fixedWeeks 
                modifiersClassNames={{
                  selected: 'my-selected',
                  today: 'my-today'
                }}
                modifiersStyles={{
                  disabled: { fontSize: '75%' }
                }}
            />
            <Moment locale="ru" format="D MMMM YYYY">
                { new Date( value || Date.now() ) }
            </Moment>
        </div>
}  

export const DateTimeDesabled = ( props: IScalarForm ): JSX.Element => {
    return <div className="d-flex my-1">
        <i className="fas fa-calendar-alt pr-1" />
        <div className="small">
            {
                !!props.value && <Moment locale="ru" format="D MMMM YYYY" className='small'>
                    {new Date(props.value * 1000)} 
                </Moment>
            } 
        </div>
    </div>
}  